export default "__VITE_ASSET__a317f7d1__"